import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  createPriceLookup,
  getPriceLookupList,
  updatePriceLookup,
} from "../../services/priceLookUpService";
import { fetchAllProducts } from "../../services/productService";
import { getFormattedProducts } from "../../helper";
import PrecisionPricing from "../../components/PrecisionPricing";
import { validateForm } from "./helper";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const PrecisionPricingPage = () => {
  const [fetchLoader, setFetchLoader] = useState(true);
  const [addLoader, setAddLoader] = useState(false);
  const [searchParams] = useSearchParams();
  const [count, setCount] = useState(0);
  const [isEdit, setIfEdit] = useState("");
  const [formModal, setFormModal] = useState(false);
  const [errors, setErrors] = useState({});
  let outletId = searchParams.get("outletId");
  let product = searchParams.get("product");
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
  });
  const [formData, setFormData] = useState({
    date: "",
    outlet: outletId,
    outletShortName: product,
    productId: "",
    productCode: "",
    price: "",
    isActive: true,
  });
  const [products, setProducts] = useState([]);
  const [lookupList, setLookupList] = useState([]);
  useEffect(() => {
    let paramsClone = { ...params, limit: 10, page: 1 };
    setParams(paramsClone);
    fetchLookupList(paramsClone);
  }, []);

  useEffect(() => {
    fetchProducts(product, outletId);
  }, [product, outletId]);

  const fetchProducts = async (category: any, outletId: any) => {
    setFetchLoader(true);
    try {
      let res = await fetchAllProducts(category, outletId);
      setProducts(getFormattedProducts(res?.data?.data));
    } catch (err: any) {
      toast.error(err?.message);
    } finally {
      setFetchLoader(false);
    }
  };

  const fetchLookupList = async (params: any) => {
    setFetchLoader(true);
    let paramsClone = {
      ...params,
      outletShortName: product,
    };
    try {
      let res = await getPriceLookupList(paramsClone);
      setLookupList(res?.data?.data);
      setCount(res?.data?.count);
    } catch (err: any) {
      toast.error(err?.message);
    } finally {
      setFetchLoader(false);
    }
  };

  const handlePriceFormSubmit = async () => {
    const errors = validateForm(formData);
    if (Object.keys(errors).length === 0) {
      let postableObj = {
        ...formData,
        date: dayjs(formData.date).format("YYYY-MM-DD"),
        price: Number(formData.price),
      };
      setAddLoader(true);
      try {
        let res = isEdit
          ? await updatePriceLookup(isEdit, postableObj)
          : await createPriceLookup(postableObj);
        fetchLookupList(params);
        setFormModal(false);
        setIfEdit("");
        setFormData({
          date: "",
          outlet: outletId,
          outletShortName: product,
          productId: "",
          productCode: "",
          price: "",
          isActive: true,
        });
      } catch (err: any) {
        toast.error(err?.message || "Something went wrong");
      } finally {
        setAddLoader(false);
      }
    } else {
      setErrors(errors);
    }
  };

  const handlePricingFormChange = (e: any) => {
    setErrors({ ...errors, [e.target.name]: "" });
    if (e.target.name === "productId") {
      let productCode = (
        products.filter((prd: any) => prd.value === e.target.value)[0] as {
          code: string;
        }
      ).code;
      setFormData({
        ...formData,
        productId: e.target.value,
        productCode,
      });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleEditClick = (data: any) => {
    setFormModal(true);
    setIfEdit(data?._id);
    setFormData({
      ...formData,
      //@ts-ignore
      date: new Date(data?.date),
      outlet: outletId,
      outletShortName: product,
      productId: String(data?.productId ?? ""),
      productCode: data?.productCode ?? "",
      price: data?.price ?? "",
      isActive: data?.isActive ?? true,
    });

    setErrors({});
  };

  const handlePageChange = (page: any) => {
    setParams({ ...params, page });
    fetchLookupList({ ...params, page });
  };
  return (
    <>
      <PrecisionPricing
        data={lookupList}
        onManagePriceClick={(val: any) => {
          setFormModal(val);
          setIfEdit("");
          setFormData({
            date: "",
            outlet: outletId,
            outletShortName: product,
            productId: "",
            productCode: "",
            price: "",
            isActive: true,
          });
        }}
        formModal={formModal}
        formData={formData}
        onPriceFormSubmit={handlePriceFormSubmit}
        onPricingFormChange={handlePricingFormChange}
        products={products}
        errors={errors}
        fetchLoader={fetchLoader}
        addLoader={addLoader}
        onEditClick={handleEditClick}
        isEdit={!!isEdit}
        page={params.page}
        limit={params.limit}
        onPageChange={handlePageChange}
        totalData={count}
      />
    </>
  );
};

export default PrecisionPricingPage;
